// extracted by mini-css-extract-plugin
var _1 = "ApplicantDocumentChecklistTypeCell-moduleApplicantDocumentChecklistTypeCell__GuXlP";
export { _1 as "ApplicantDocumentChecklistTypeCell" }
